import { render, staticRenderFns } from "./WDGHeader.vue?vue&type=template&id=86ff73ee&"
import script from "./WDGHeader.vue?vue&type=script&lang=js&"
export * from "./WDGHeader.vue?vue&type=script&lang=js&"
import style0 from "./WDGHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports